/* ============
 * Job Actions Store
 * ============
 */

import { defineStore } from 'pinia';
import './pinia';

export const useJobActionsStore = defineStore('jobActions', {
  state: () => ({
    visible: false,
    job: null,
    type: null,
    requirements: null,
    // Was `open` under Vuex. Pinia merges state, getters and actions into a
    // single namespace, so it would have collided with the `open()` action.
    expanded: true,
    jobStatusChange: null,
  }),

  actions: {
    open(data) {
      this.visible = true;
      this.job = data.job;
      this.type = data.type;
      this.requirements = data.requirements;
    },

    close() {
      this.visible = false;
      this.job = null;
      this.type = null;
      this.requirements = null;
      this.jobStatusChange = null;
    },

    changeStatus(data) {
      this.job.status = data.jobChange.status;
    },
  },
});

export default useJobActionsStore;
